export const emailExpression =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneExpression = /^([2-9]\d{2}[-]\d{3}[-]\d{4}?|^$)$/;
export const zipCodeExpression = /^[0-9]{5}(?:-[0-9]{4})?$/;
